<template>
  <div class="my-pro">
    <div class="pro-content">
      <!-- <div class="card-content" :span="6" style="float:left">
          <div class="card add-card">
            <span style="cursor:pointer;" @click="newScene">
              <div class="new-card">
                <a-icon style="font-size:22px" type="plus" />
              </div>
              <div class="new-card-text" style="margin-top:6px;">新建场景</div>
            </span>
          </div>
      </div> -->
      <div class="operation-btn-group">
        <a-row :gutter="16">
          <a-col class="gutter-row" :span="4">
            <div class="gutter-box">
              <div class="operation-btn-list" @click="createPro(1)">
                <img src="../../assets/img/phone-sence.png" alt="">
                <span>智能电话</span>
                <a-icon type="plus" />
              </div>
            </div>
          </a-col>
          <a-col class="gutter-row" :span="5">
            <div class="gutter-box">
              <div class="operation-btn-list" @click="createPro(5)">
                <img src="../../assets/img/gpt.png" alt="">
                <span>Chatgpt助手</span>
                <a-icon type="plus" />
              </div>
            </div>
          </a-col>
          <a-col class="gutter-row" :span="4">
            <div class="gutter-box">
              <div class="operation-btn-list" @click="createPro(2)">
                <img src="../../assets/img/word-sence.png" alt="">
                <span>文字客服</span>
                <a-icon type="plus" />
              </div>
            </div>
          </a-col>
          <a-col class="gutter-row" :span="4">
            <div class="gutter-box">
              <div class="operation-btn-list" @click="createPro(3)">
                <img src="../../assets/img/video-sence.png" alt="">
                <span>视频客服</span>
                <a-icon type="plus" />
              </div>
            </div>
          </a-col>
          <a-col class="gutter-row" :span="4">
            <div class="gutter-box">
              <div class="operation-btn-list" @click="createPro(4)">
                <img src="../../assets/img/h5-sence.png" alt="">
                <span>H5数字人</span>
                <a-icon type="plus" />
              </div>
            </div>
          </a-col>
          
        </a-row>
      </div>
      <div class="pro-tab">
        <span :class="currentProTab==0?'active':''" @click="selectProTab(0)">全部项目</span>
        <span :class="currentProTab==1?'active':''" @click="selectProTab(1)">智能电话</span>
        <span :class="currentProTab==5?'active':''" @click="selectProTab(5)">Chatgpt助手</span>
        <span :class="currentProTab==2?'active':''" @click="selectProTab(2)">文字客服</span>
        <span :class="currentProTab==3?'active':''" @click="selectProTab(3)">视频客服</span>
        <span :class="currentProTab==4?'active':''" @click="selectProTab(4)">H5数字人</span>
        
      </div>
      <!-- <div class="card-content" v-for="(item, index) in proList" :key="index" :class="{'card-distance':((index+1)%4!=0)}">
        <div class="card">
            <div class="card-title" style="padding:0 24px;">
              <span style="font-weight:600" :title="item.name">{{item.name.length>14?item.name.substring(0,14)+'...':item.name}}</span>
              <span style="float:right;color:rgba(204, 204, 204, 1);font-size:12px;margin-top:4px;">ID：{{item.id}}</span>
            </div>
            <div style="padding:0 24px">
              <span style="display:inline-block;width:70%">
                <a-progress :percent="randomNum()" status="active" strokeColor='rgba(34, 215, 187, 1)' :strokeWidth='4' :showInfo='false'/>
              </span>
              <span style="color:rgba(204, 204, 204, 1);font-size:12px;margin-left:10px;float:right;margin-top:3px;">智能度:{{randomNum()}}%</span>
            </div>
            <div class="card-tag" style="padding:0 24px">
              <span style="color:#fa8c16;margin-right:8px;" v-if="item.type=='IN'">[呼入]</span>
              <span style="color:rgba(78, 138, 250, 1);margin-right:8px;" v-if="item.type=='OUT'">[呼出]</span>
              <span>节点:</span>
              <span :class="{'call-type-in':item.type=='IN'}" style="margin-right:15px;">{{item.nodeCount}}</span>
              <span>意图:</span>
              <span :class="{'call-type-in':item.type=='IN'}" style="margin-right:15px;">{{item.intentionCount}}</span>
              <span>样本:</span>
              <span :class="{'call-type-in':item.type=='IN'}" style="margin-right:15px;">{{item.sampleCount}}</span>
            </div>
            <div style="clear:both"></div>
            <div style="color:rgba(204, 204, 204, 1);font-size:12px;margin-top:10px;padding:0 24px">
              <a-row>
                <a-col :span="8">
                  <span class="path-num" @click="jumpToPath()" style="color:rgba(153, 153, 153, 1);font-size:12px;cursor:pointer">通道数量：{{item.channelCount}}</span>
                </a-col>
                <a-col :span="8">
                  <span>{{item.createTime}}</span>
                </a-col>
                <a-col :span="8">
                  <div style="float:right">
                    <a-switch @change="changeSwitch(item)" :checked="item.shared=='NO'?false:true" />
                    <span style="margin-left:6px;color:rgba(153, 153, 153, 1);font-size:12px;">分享</span>
                  </div>
                </a-col>
              </a-row>
            </div>
            <div style="clear:both"></div>
            <div class="design-state" style="color:rgba(153, 153, 153, 1);background:#f8f9f9;height:35px;">
              <span @click="operate(index,'audio',item)" style="display:inline-block;width:25%;float:left;height:35px;line-height:35px;text-align:center;cursor:pointer">
                <a-icon style="margin-right:6px" type="audio" />文字模拟
                <span style="display:inline-block;height:15px;width:1px;background:rgba(221, 221, 221, 1);margin-top:10px;float:right"></span>
              </span>
              <span @click="operate(index,'edit',item)" style="display:inline-block;width:25%;float:left;height:35px;line-height:35px;text-align:center;cursor:pointer">
                <a-icon style="margin-right:6px" type="edit" />场景设计
                <span style="display:inline-block;height:15px;width:1px;background:rgba(221, 221, 221, 1);margin-top:10px;float:right"></span>
              </span>
              <span @click="operate(index,'database',item)" style="display:inline-block;width:25%;float:left;height:35px;line-height:35px;text-align:center;cursor:pointer">
                <a-icon style="margin-right:6px" type="bar-chart" />数据查询
                <span style="display:inline-block;height:15px;width:1px;background:rgba(221, 221, 221, 1);margin-top:10px;float:right"></span>
              </span>
              <span @click="moreAction(index,item)" style="display:inline-block;width:25%;float:left;cursor:pointer;height:35px;line-height:35px;text-align:center">
                <span style="float:left;margin-left:20px">更多</span>
                <a-icon style="float:left;margin-top:9px;margin-left:5px;font-size:17px" class="three-point" id="three-point" type="ellipsis" />
              </span>
            </div>
            <ul class="card-list" v-if="item.ifShow">
              <li @click="operate(index,'heat-map',item)"><a-icon type="book" /><span>改名</span></li>
              <li @click="operate(index,'view-port',item)"><a-icon type="profile" /><span>标签</span></li>
              <li @click="operate(index,'experience',item)"><a-icon type="coffee" /><span>体验</span></li>
              <li @click="operate(index,'copy',item)"><a-icon type="copy" /><span>克隆</span></li>
              <li @click="operate(index,'delete',item)"><a-icon type="delete" /><span>删除</span></li>
            </ul>
        </div>
      </div> -->
      <div class="pro-group">
        <div class="pro-list" v-for="(item, index) in proList" :key="index" @click="viewProDetail(item)">
          <div class="pro-item-head">
            <img v-if="item.purpose==1" src="../../assets/img/phone-sence.png" alt="">
            <img v-if="item.purpose==2" src="../../assets/img/word-sence.png" alt="">
            <img v-if="item.purpose==3" src="../../assets/img/video-sence.png" alt="">
            <img v-if="item.purpose==4" src="../../assets/img/h5-sence.png" alt="">
            <img v-if="item.purpose==5" src="../../assets/img/gpt.png" alt="">
            <div class="pro-item-content">
              <div :title="item.name">{{ item.name }}</div>
              <div>ID：{{item.id}}</div>
            </div>
            <a-icon type="heart" :class="item.isAttention==1?'active':''" @click="addAttention(item.isAttention,item.id)"/>
          </div>
          <div class="pro-item-date">
            <span>创建时间：</span>
            <span>{{item.createTime}}</span>
          </div>
        </div>
        <div v-if="proList.length == 0" style="text-align: center;position:absolute;top:50%;margin-top:-150px;left:50%;margin-left:-90px">
          <img style="width:180px;" src="../../assets/img/recycle-bin.png" alt="">
          <div>暂无数据，请新建场景</div>
        </div>
      </div>
    </div>
    <!-- <router-link target="_blank" rel="opener" to="/Communication" class="dialogBox">
      <a-icon style="z-index:1000;font-size:25px" type="message" />
    </router-link> -->
    <a-modal
      :mask-closable="true"
      title="项目名称"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
      okText="确认" cancelText="取消"
    >
      <div class="">
        <a-input v-model="newName" />
      </div>
    </a-modal>
    <a-modal
      width="1145px"
      style="overflow-y:auto;"
      :mask-closable="true"
      title="回收站"
      :visible="ifShowRecycle "
      @ok="btnSure"
      @cancel="btnOff"
      :footer="null"
      okText="确认" cancelText="取消"
      id="recycle-bin"
    >
      <div style="max-height:600px;overflow-y:auto">
        <div class="card-content" :span="6" v-for="(item, index) in deleteProList" :key="index" style="width:348px;height:178px;display:inline-block;margin:0 16px 16px 0;box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);">
          <div class="card" style="border:none;height:178px;width:348px;display:inline-block;box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.1);">
            <div style="padding:28px 24px 0">
              <div class="card-title" style="color:rgba(51, 51, 51, 1);font-size:16px;">
                <span :title="item.name">{{item.name.length>17?item.name.substring(0,17)+'...':item.name}}</span>
              </div>
              <div style="clear:both"></div>
              <div class="card-tag" style="height:30px">
                <span style="color:#fa8c16;margin-right:8px;" v-if="item.type=='IN'">[呼入]</span>
                <span style="color:rgba(78, 138, 250, 1);margin-right:8px;" v-if="item.type=='OUT'">[呼出]</span>
                <span>节点:</span>
                <span :class="{'call-type-in':item.type=='IN'}" style="margin-right:15px;">{{item.nodeCount}}</span>
                <span>意图:</span>
                <span :class="{'call-type-in':item.type=='IN'}" style="margin-right:15px;">{{item.intentionCount}}</span>
                <span>样本:</span>
                <span :class="{'call-type-in':item.type=='IN'}" style="margin-right:15px;">{{item.sampleCount}}</span>
              </div>
              <div class="design-state" style="margin-top:18px">
                <span style="float:left;font-size:12px;color:rgba(204, 204, 204, 1)">项目ID：{{item.id}}</span>
                <span style="float:right;font-size:12px;color:rgba(204, 204, 204, 1)">{{item.createTime}}</span>
              </div>
            </div>
              
              <div style="clear:both"></div>
              <div style="margin-top:15px">
                <span style="width:50%;height:35px;display:inline-block;text-align:center;line-height:35px;cursor:pointer;color:rgba(255, 70, 70, 1);font-size:12px;background:rgba(245, 246, 247, 0.5)" @click="deleteRecoveryPro(item.id)">删除
                  <span style="width:1px;height:15px;background:rgb(221, 221, 221);display:inline-block;float:right;margin-top:11px"></span>
                </span>
                <span style="width:50%;height:35px;display:inline-block;text-align:center;line-height:35px;cursor:pointer;color:rgba(34, 215, 187, 1);font-size:12px;background:rgba(245, 246, 247, 0.5)" @click="recoveryItem(item.id)">恢复</span>
              </div>
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal
      :mask-closable="false"
      :visible="newProModal"
      :closable="false"
      :footer="null"
      width="800px"
    >
      <div style="display:flex;height:450px">
        <div style="width:304px;height:100%;background:rgba(244, 244, 245, 1);padding:0 32px">
          <div style="text-align:center;padding:48px 0 32px">
            <img v-if="currentProType==1" style="width:160px;" src="../../assets/img/create-sense1.png" alt="">
            <img v-if="currentProType==2" style="width:160px;" src="../../assets/img/create-sense2.png" alt="">
            <img v-if="currentProType==3" style="width:160px;" src="../../assets/img/create-sense3.png" alt="">
            <img v-if="currentProType==4" style="width:160px;" src="../../assets/img/create-sense4.png" alt="">
            <img v-if="currentProType==5" style="width:160px;" src="../../assets/img/create-sense5.png" alt="">
          </div>
          <div style="color:rgba(18, 18, 18, 1);font-size:20px;font-weight:bold;">
            <span v-if="currentProType==1">新建智能电话场景</span>
            <span v-if="currentProType==2">新建文字客服场景</span>
            <span v-if="currentProType==3">新建视频客服场景</span>
            <span v-if="currentProType==4">新建H5数字人场景</span>
            <span v-if="currentProType==5">新建Chatgpt助手</span>
          </div>
          <div style="color:rgba(80, 80, 80, 1);font-size:13px;margin-top:16px;">
            <span v-if="currentProType==1">市场调研，问卷调查，预约服务，内容通知，会员营销，账单催缴，智能热线，老客户唤醒......</span>
            <span v-if="currentProType==2">电商小二，网站客服，群机器人，公众号回复，小程序客服，问答助手，对话式帮助系统......</span>
            <span v-if="currentProType==3">视频连线咨询，客户信息采集，多媒体信息展示，金融审核，远程教育，健康指导......</span>
            <span v-if="currentProType==4">具备可视化、交互性强、易传播等特点，应用于各种数字化营销、教育培训、互动娱乐、品牌推广、社交媒体等方面</span>
            <span v-if="currentProType==5">可以根据用户的职业需求创建助手人设。用户可以自定义助手的性格、语言风格、知识领域等，使其更符合自己的使用需求。GPT助手可以帮助用户完成各种工作，例如回答常见问题、提供相关信息、执行简单任务等。</span>
          </div>
        </div>
        <div style="flex:1;height:100%;background:rgba(255, 255, 255, 1);padding:0 0 0 32px;position:relative">
          <div style="position:relative;">
            <a-icon @click="offCreateSence" style="position:absolute;right:-12px;top:0px;font-size:18px;color:rgba(158, 172, 196, 1);cursor:pointer;" type="close" />
          </div>
          <div style="color:rgba(18, 18, 18, 1);font-size:16px;margin-top:64px;margin-bottom:16px">请输入你的项目名称：</div>
          <a-input placeholder="" v-model="newSenceName" />
          <span @click="sureCreateSence" style="width:72px;height:36px;border-radius:6px;text-align:center;line-height:36px;color:#fff;background:rgba(34, 215, 187, 1);cursor:pointer;display:inline-block;position:absolute;right:0px;bottom:0px">确认</span>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: 'name',
    dataIndex: 'name',
    width: '25%',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'age',
    dataIndex: 'age',
    width: '15%',
    scopedSlots: { customRender: 'age' },
  },
  {
    title: 'address',
    dataIndex: 'address',
    width: '40%',
    scopedSlots: { customRender: 'address' },
  },
  {
    title: 'operation',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

const data = [];
export default {
  name: 'MyProject',
  props: {
    msg: String
  },
  data() {
    this.cacheData = data.map(item => ({ ...item }));
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
      data,
      columns,
      editingKey: '',
      keyword: '',
      proList: [],
      visible: false,
      newName: '',
      projectId: '',
      ifShowRecycle: false,
      deleteProList: [],
      currentProTab: 0,
      proAllList: [],
      currentProType: '',
      newProModal: false,
      newSenceName: '',
      isAttention: false,
    };
  },
  methods: {
    randomNum() {
      var n = parseInt(Math.random()*20+0)
      return n+80
    },
    confirm(id) {
      this.$confirm({
        title: '提示',
        content: '确认要删除吗？',
        okText: '确认',
        cancelText: '取消',
        icon: 'warning',
        onOk: ()=> {
          this.deleteProItem(id)
        },
      })
    },
    confirmCopy(id) {
      this.$confirm({
        title: '提示',
        content: '确认要克隆该项目吗？',
        okText: '确认',
        cancelText: '取消',
        icon: 'warning',
        onOk: ()=> {
          this.copyPro(id)
        },
      })
    },
    onSearch(value) {
      this.keyword = value
      this.queryAllProList() 
    },
    // moreAction(index) {
    //   event.stopPropagation();
    //   if(this.proList[index]['ifShow']){
    //     this.proList[index]['ifShow'] = false 
    //   }else{
    //     for(let i = 0; i < this.proList.length; i++){
    //       this.proList[i]['ifShow'] = false
    //     }
    //     this.proList[index]['ifShow'] = true 
    //   }
    //   this.$forceUpdate();
    // },
    newScene() {
      this.$router.push("/NewSpeak")
    },
    operate(index,param,item) {
      this.projectId = item.id
      if(param == 'delete'){
        this.confirm(item.id)
      }else if(param == 'heat-map'){
        this.visible = true
        this.newName = item.name
      }else if(param == 'edit'){
        this.$router.push({path: '/PublicPart',query:{projectId:this.projectId,projectName:item.name}});
      }else if(param == 'copy'){
        this.confirmCopy(item.id)
      }else if(param == 'view-port'){
        this.$router.push({path: '/DataView',query:{projectId:this.projectId}});
      }else if(param == 'audio'){
        let routeData = this.$router.resolve({path: '/Communication',query:{projectId:this.projectId,projectName:item.name,type:'myPro'}});
        window.open(routeData.href, '_blank');
      }else if(param == 'database'){
        this.$router.push({path: '/Dialogues',query:{projectId:this.projectId}});
      }else if(param == 'experience'){
        let routeData = this.$router.resolve({path: '/Chat',query:{projectId:this.projectId,projectName:item.name,des:item.description}});
        window.open(routeData.href, '_blank');
      }
    },
    copyPro(id){
      this.axios.post('/api/project/copy', {
        id: id,
      })
      .then(response=> {
        if(response.data.code == 0){
          this.queryAllProList()
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    deleteProItem(id) {
      this.axios.post('/api/project/delete', {
          id: id,
      })
      .then(response=> {
          if(response.data.code == 0){
            this.queryAllProList()
          }else{
            this.$message.error(response.data.message);
          }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    queryAllProList() {
      this.axios(
        {
          method:'get',
          url:'/api/project/list', 
          params: {
            keyword: this.keyword,
            type: '',
            status: '',
            hasDelete: false
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.proAllList = response.data.data
          this.proList = []
          if(this.currentProTab == 0){
            if(this.isAttention){
                for(let i = 0; i < this.proAllList.length; i++){
                  if(this.proAllList[i]['isAttention'] == 1){
                  this.proList.push(this.proAllList[i])
                }
              }
            }else{
              this.proList = response.data.data
            }
          }else{
            if(this.isAttention){
              for(let i = 0; i < this.proAllList.length; i++){
                if(this.proAllList[i]['purpose'] == this.currentProTab&&this.proAllList[i]['isAttention'] == 1){
                  this.proList.push(this.proAllList[i])
                }
              }
            }else{
              for(let i = 0; i < this.proAllList.length; i++){
                if(this.proAllList[i]['purpose'] == this.currentProTab){
                  this.proList.push(this.proAllList[i])
                }
              }
            }
            
          }
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    queryDeleteProList() {
      this.axios(
        {
          method:'get',
          url:'/api/project/list', 
          params: {
            keyword: '',
            status: '',
            type: '',
            hasDelete: true
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.deleteProList = response.data.data
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    handleOk() {
      this.axios.post('/api/project/name', {
          id: this.projectId,
          name: this.newName
      })
      .then(response=> {
          if(response.data.code == 0){
            this.queryAllProList()
          }else{
            this.$message.error(response.data.message);
          }
          this.visible = false
      })
      .catch(error=> {
          console.log(error)
      })
    },
    handleCancel() {
      this.visible = false;
    },
    btnSure() {
      this.ifShowRecycle = false;
    },
    btnOff() {
      this.ifShowRecycle = false;
    },
    showRecycle() {
      this.ifShowRecycle = true;
      this.queryDeleteProList()
    },
    recoveryItem(id) {
      this.axios.post('/api/project/recycleBin/recovery', {
          id: id,
      })
      .then(response=> {
          if(response.data.code == 0){
            // this.queryDeleteProList()
            this.queryAllProList()
          }else{
            this.$message.error(response.data.message);
          }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    deleteRecoveryPro(id) {
      this.axios.post('/api/project/recycleBin/delete', {
          id: id,
      })
      .then(response=> {
          if(response.data.code == 0){
            this.queryDeleteProList()
          }else{
            this.$message.error(response.data.message);
          }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    changeSwitch(item) {
      let shared = ''
      if(item.shared == 'NO'){
        shared = 1
      }else{
        shared = 2
      }
      this.axios.post('/api/project/share', {
          id: item.id,
          operateType: shared
      })
      .then(response=> {
          if(response.data.code == 0){
            this.$message.success('操作成功')
            this.queryAllProList()
          }else{
            this.$message.error(response.data.message);
          }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    jumpToPath() {
      this.$router.push("/Account/PathManage")
    },
    addAttention(flag, id) {
      event.stopPropagation();
      if(flag == 1){
        this.axios.post('/api/project/cancelAttention', {
          projectId: id,
        })
        .then(response=> {
          if(response.data.code == 0){
            this.$message.success('取关成功')
            this.queryAllProList()
            this.$emit('changeAttention', false)
          }else{
            this.$message.error(response.data.message);
          }
        })
        .catch(error=> {
          console.log(error)
        })
      }else{
        this.axios.post('/api/project/attention', {
          projectId: id,
        })
        .then(response=> {
          if(response.data.code == 0){
            this.$message.success('关注成功')
            this.queryAllProList()
            this.$emit('changeAttention', false)
          }else{
            this.$message.error(response.data.message);
          }
        })
        .catch(error=> {
          console.log(error)
        })
      }
    },
    viewProDetail(item) {
      this.$emit('changeId', item.id)
      if(item.purpose == 5){
        this.$emit('changeFatherData', '2')
        let data = JSON.stringify(item.id)
        this.$router.push({
          path:'/GptDetail',
          query: {
            id: data
          }
        })
      }else{
        this.$emit('changeFatherData', '2')
        let data = JSON.stringify(item.id)
        this.$router.push({
          path:'/ProDetail',
          query: {
            id: data
          }
        })
      }
    },
    selectProTab(data) {
      this.currentProTab = data
      this.proList = []
      if(this.currentProTab == 0){
        if(this.isAttention){
          for(let i = 0; i < this.proAllList.length; i++){
            if(this.proAllList[i]['isAttention'] == 1){
              this.proList.push(this.proAllList[i])
            }
          }
        }else{
          this.proList = this.proAllList
        }
      }else{
        if(this.isAttention){
          for(let i = 0; i < this.proAllList.length; i++){
            if(this.proAllList[i]['purpose'] == this.currentProTab&&this.proAllList[i]['isAttention'] == 1){
              this.proList.push(this.proAllList[i])
            }
          }
        }else{
          for(let i = 0; i < this.proAllList.length; i++){
            if(this.proAllList[i]['purpose'] == this.currentProTab){
              this.proList.push(this.proAllList[i])
            }
          }
        }
      }
    },
    createPro(type) {
      this.currentProType = type
      this.newProModal = true
    },
    offCreateSence() {
      this.newProModal = false
    },
    sureCreateSence() {
      this.newProModal = false
      if(this.currentProType == 1){
        this.axios.post('/api/project', {
          name: this.newSenceName,
          purpose: this.currentProType
        })
        .then(response=> {
          if(response.data.code == 0){
            this.queryAllProList()
          }else{
              this.$message.error(response.data.message);
          }
        })
        .catch(error=> {
          console.log(error)
        })
      }else if(this.currentProType == 5){
        // this.$router.push({path: '/Gpt',query:{name:this.newSenceName}});
        let routeData = this.$router.resolve({
          path: '/Gpt',
          query:{
            name:this.newSenceName,
          }
        });
        window.open(routeData.href, '_blank');
      }else{
        this.$message.warning('暂时无法创建该类型项目')
      }
    }
  },
  mounted: function() {
    // this.sessionData('set','currentMenu','MyProject');
    this.isAttention = this.$route.query.isAttention
    if(this.isAttention){
      this.sessionData('set','currentMenu','MyAttention')
    }else{
      this.sessionData('set','currentMenu','MyProject')
    }
    this.queryAllProList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped  lang="less">
  .my-pro{
    height: 100%;
    // background: #eee;
    padding:4px 0px 24px 24px;
    overflow-y: auto;
    position: relative;
    .pro-content{
      // width: 1440px;
      margin: 0 auto;
      padding: 0;
      // background: #fff;
      border-radius: 8px;
      .operation-btn-group{
        padding: 32px 24px 32px 0;
        .operation-btn-list{
          height: 56px;
          line-height: 56px;
          border-radius: 8px;
          border: 1px solid rgba(229, 231, 235, 1);
          background: rgba(244, 244, 245, 1);
          cursor: pointer;
          font-size: 16px;
          color: rgba(18, 18, 18, 1);
          padding: 0 16px;
          img{
            width: 32px;
            float: left;
            margin: 10px 8px 0 0;
          }
          i{
            float: right;
            margin-top: 20px;
            color: rgba(158, 172, 196, 1);
            font-size: 18px;
            font-weight: bold;
          }
        }
      }
      .pro-tab{
        border-bottom: 1px solid rgba(229, 231, 235, 1);
        margin-bottom: 24px;
        span{
          display: inline-block;
          padding-bottom: 5px;
          color: #505050;
          font-size: 14px;
          margin-right: 28px;
          cursor: pointer;
        }
        span.active{
          color: rgba(34, 215, 187, 1);
          border-bottom: 3px solid rgba(34, 215, 187, 1);
        }
      }
      .pro-group{
        .pro-list{
          display: inline-block;
          width: 526px;
          height: 134px;
          background: #fff;
          cursor: pointer;
          box-shadow: rgba(229, 231, 235, 1) solid 1px;
          border: 1px solid rgba(229, 231, 235, 1);
          margin: 0 16px 16px 0;
          border-radius: 8px;
          padding: 24px 20px 0 20px;
          .pro-item-head{
            display: flex;
            img{
              width: 52px;
              height: 52px;
              margin-right: 12px;
            }
            .pro-item-content{
              flex: 1;
              div:nth-child(1){
                font-size: 18px;
                color: rgba(18, 18, 18, 1);
                font-weight: bold;
                overflow: hidden;
                height: 30px;
              }
              div:nth-child(2){
                font-size: 12px;
                margin-top: 4px;
                color: rgba(158, 172, 196, 1);
              }
            }
            i{
              font-size: 16px;
              margin-left: 24px;
              margin-top: 4px;
              cursor: pointer;
            }
            i.active{
              color: rgba(227, 60, 100, 1);
            }
          }
          .pro-item-date{
            text-align: right;
            margin-top: 20px;
            color: rgba(158, 172, 196, 1);
            font-size: 12px;
          }
          .pro-item-btn{
            span{
              display: inline-block;
              width: 100px;
              height: 36px;
              border: 1px solid rgba(229, 229, 229, 1);
              font-size: 14px;
              cursor: pointer;
              text-align: center;
              line-height: 36px;
            }
            span:nth-child(1){
              margin-right: 11px;
            }
          }
        }
        .pro-list:hover{
          border: 1px dotted rgba(34, 215, 187, 1);
        }
      }
      .card-content{
        display:inline-block;
        width: 348px;
        margin-top:16px;
      }
      .card-distance{
        margin-left:16px
      }
      .delete{
        position: fixed;
        right: 24px;
        bottom: 24px;
        cursor: pointer;
        width: 108px;
        height:40px;
        line-height: 40px;
        background: #fff;
        color: rgba(80, 80, 80, 1);
        font-size: 14px;
        box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.075);
        text-align: center;
      }
      .delete:hover{
        color: #22d7bb;
      }
      .card{
        width: 100%;
        padding: 28px 0px 0px;
        cursor: default;
        height:192px;
        box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.06);
        border: 1px solid #fff;
        // margin-top: 20px;
        // box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.5);
        position: relative;
        background:#fff;
        // i{
        //   color: #1890ff;
        // }
        // i.call-type-in{
        //   color: rgba(255, 196, 66, 1);
        // }
        .new-card{
          display: inline-block;
          width: 25px;
          height: 25px;
          color: rgba(34, 215, 187, 1);
          font-size: 18px;
          // font-weight: 600;
          border-radius: 8px;
          text-align: center;
          line-height: 25px;
          // background: #13C2C2;
        }
        .new-card-text{
          font-size: 16px;
          // font-weight: bold;
          margin-left: 5px;
        }
        .card-time{
          text-align: right;
          margin: 11px 0;
          font-size: 12px;
        }
        .design-state{
          margin-top: 21px;
          font-size: 12px;
          // span:nth-child(1){
          //   margin-right: 100px;
          //   font-size: 14px;
          //   color: rgba(34, 215, 187, 1);
          // }
          color: rgba(204, 204, 204, 1);
        }
        .card-list{
          position: absolute;
          bottom: 20px;
          right: -40px;
          z-index: 100;
          width: 100px;
          height: 208px;
          color: rgba(80, 80, 80, 1);
          background-color: rgba(255, 255, 255, 1);
          font-size: 14px;
          line-height: 41px;
          box-shadow: 0px 9px 9px 0px rgba(0, 0, 0, 0.2);
          text-align: center;
          // display: none;
          li{
            cursor: pointer;
            span{
              margin-left: 8px;
            }
          }
          li:hover{
            background: #eee;
          }
        }
      }
      .card:hover{
        border: 1px dotted rgba(34, 215, 187, 1);
      }
      .add-card{
        text-align: center;
        font-size: 18px;
        padding-top:65px;
        color: rgba(34, 215, 187, 1);
        // line-height: 135px;
      }
      .three-point{
        font-size: 20px;
        font-weight: 300;
        transform: rotate(90deg);
        -ms-transform: rotate(90deg); /* IE 9 */
        -moz-transform: rotate(90deg); /* Firefox */
        -webkit-transform: rotate(90deg); /* Safari and Chrome */
        -o-transform: rotate(90deg); /* Opera */
      }
      .card-title span:nth-child(1){
        display: inline-block;
        // width: 100%;
        font-size: 16px;
        border: 1px solid #fff;
        color: rgba(80, 80, 80, 1);
      }
    }
  }
  .card-tag{
    font-size: 12px;
    margin-top: 10px;
    span{
      float: left;
      font-size: 14px;
      color: rgba(153, 153, 153, 1);
    }
    span:nth-child(even){
      // margin-right: 24px;
      border-radius: 4px;
      min-width: 20px;
      display: inline-block;
      text-align: center;
      height: 22px;
      line-height: 22px;
    }
    span.call-type-in{
      // color: rgba(255, 196, 66, 1);
    }
    span:nth-child(odd){
      margin-right: 1px;
    }
  }
  .path-num:hover{
    text-decoration: underline;
  }
</style>
